$.Calendario.prototype._getBody =  function() {
    var d = new Date( this.year, this.month + 1, 0 ),
    // number of days in the month
    monthLength = d.getDate(),
    firstDay = new Date( this.year, this.month, 1 );

    // day of the week
    this.startingDay = firstDay.getDay();

    var html = '<div class="fc-body"><div class="fc-row">',
        // fill in the days
        day = 1;

    // this loop is for weeks (rows)
    for ( var i = 0; i < 7; i++ ) {

        // this loop is for weekdays (cells)
        for ( var j = 0; j <= 6; j++ ) {

            var pos = this.startingDay - this.options.startIn,
                p = pos < 0 ? 6 + pos + 1 : pos,
                inner = '',
                today = this.month === this.today.getMonth() && this.year === this.today.getFullYear() && day === this.today.getDate(),
                content = '';

            if ( day <= monthLength && ( i > 0 || j >= p ) ) {
                inner += '<span class="fc-date">' + day + '</span><span class="fc-weekday">' + this.options.weekabbrs[ j + this.options.startIn > 6 ? j + this.options.startIn - 6 - 1 : j + this.options.startIn ] + '</span>';

                // this day is:
                var strdate = ( this.month + 1 < 10 ? '0' + ( this.month + 1 ) : this.month + 1 ) + '-' + ( day < 10 ? '0' + day : day ) + '-' + this.year,
                    dayData = this.caldata[ strdate ];

                if( dayData ) {
                    content = dayData;
                }

                if( content !== '' ) {
                    inner += '<div>' + content + '</div>';
                }

                ++day;

            }
            else {
                today = false;
            }

            var cellClasses = today ? 'fc-today ' : '';
            if( content !== '' ) {
                cellClasses += 'fc-content';
            }

            var wd = new Date( this.year, this.month, day).getUTCDay();
            if ( wd === 0 ) {
                cellClasses += ' sunday';
            }
            if ( wd === 6 ) {
                cellClasses += ' saturday';
            }

            html += cellClasses !== '' ? '<div class="' + cellClasses + '">' : '<div>';
            html += inner;
            html += '</div>';

        }

        // stop making rows if we've run out of days
        if (day > monthLength) {
            this.rowTotal = i + 1;
            break;
        }
        else {
            html += '</div><div class="fc-row">';
        }

    }
    html += '</div></div>';

    return html;
};